import { createContext, useContext } from 'react';
import { getFramework } from './framework';

/** 创建平台上下文 */
export const StoreContext = createContext<object | null>(null);

/** 通过 hook 获取 state */
export function useState<T>() {
    const stores = useContext(StoreContext);
    if (!stores) throw new Error('Missing StoreProvider');
    return stores as T;
}

/** 通过 api 获取 state */
export function getState<T>(identity: string) {
    // return InstanceData.getData(identity, InstanceDataType.State) as T;
    return getFramework(identity).service.registration.states as T;
}
